import { getDeviceUuid, getSignature } from '../components/BalancesList/helpers';
import strings from '../localization';
import { AIRDROP_BACKEND_URL } from '../utils/env-variables';
import { chromeLocalStorage } from '../utils/chrome-storage-polyfill';
import { CaptchaPrefetchProps } from '../components/BalancesList/CaptchaDialog';

export class RateLimitError extends Error {
}

export default class AirdropService {
  async register(wallet: any): Promise<boolean> {
    // Get hCaptcha token from storage
    const prefetchData = await this.getPrefetchData();
    if (!prefetchData?.hcaptchaToken) {
      throw new Error('Please complete captcha verification first');
    }

    const response = await fetch(
      `${AIRDROP_BACKEND_URL}/v1/register-device`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          domichainAddress: wallet.publicKey.toBase58(),
          deviceUuid: getDeviceUuid(),
          signature: await getSignature(wallet),
          hcaptchaToken: prefetchData.hcaptchaToken,
        }),
      },
    );

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      
      if (response.status === 429) {
        if ('error' in body) {
          throw new RateLimitError(body.error.message);
        }
      }
      
      if (response.status === 400 && body.error?.message?.includes('captcha')) {
        // Clear invalid captcha token
        await this.clearPrefetchData();
        throw new Error('Captcha verification failed. Please try again.');
      }
      
      throw new Error(strings.errorOccurredTryAgainLater);
    }

    // Clear the used captcha token from storage after successful use
    await this.clearPrefetchData();
    return true;
  }

  private async getPrefetchData(): Promise<CaptchaPrefetchProps | null> {
    return new Promise((resolve) => {
      chromeLocalStorage.get(['tmpPrefetch'], (result) => {
        resolve(result.tmpPrefetch || null);
      });
    });
  }

  private async clearPrefetchData(): Promise<void> {
    return new Promise((resolve) => {
      chromeLocalStorage.remove(['tmpPrefetch'], () => {
        resolve();
      });
    });
  }
}